<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" :appendToBody="true" width="1200px">
        <div class="detailContent">
            <el-form v-show="isEdit" ref="form" :model="dioForm" :rules="rules" label-width="120px">
                <el-form-item :label="$t('public.table_scope')" prop="scopeText"
                    v-if="$store.state.type === 3 || $store.state.type === 2">
                    <span>{{ dioForm.scopeName }}</span>
                    <i class="el-icon-edit" style="float:right" @click="handleEditFn"></i>
                </el-form-item>
                <el-form-item :label="$t('alarm.alarm_cause')" prop="alarmReason">
                    <div class="disClass">
                        <div class="reasonClass">
                            <div class="reasonRontent" v-for="(item, index) in reasonArray" :key="index">
                                <div class="textDiv">{{ item.checkValue | filterFn }}</div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('alarm.alarm_time')" prop="alarmTime">
                    <div class="alarmTime" v-for="item in timePoint" :key="item.id">
                        <div class="weekClass">{{ item.alarmTime | timeWeek }}</div>
                        <!-- 说一下 这里key+week 是为了防止key重复 -->
                        <div class="timePoint" v-for="(option, k) in item.alarmTimeList" :key="k + 'week'">
                            <div class="timepointContent">
                                <span class="time">{{ option.startTime }}</span>
                                <span style="margin:0 5px">To</span>
                                <span class="time">{{ option.endTime }}</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <!-- 如果是查阅模式 且 重复报警未开启 则隐藏 三项 -->
                <template v-if="isConsultMode && dioForm.type">
                    <el-col :span="24">
                        <el-col :span="4">
                            <el-form-item :label="$t('integration.interval_alarm_or_not')" prop="alarmTime">
                                <el-checkbox v-model="dioForm.type" disabled :true-label="1" :false-label="0"></el-checkbox>
                            </el-form-item>
                        </el-col>

                        <!-- 与重复报警勾选互斥 -->
                        <template v-if="dioForm.type">
                            <!-- <el-col :span="4">
                                <el-form-item :label="$t('alarm.repeat_times')" prop="alarmTime">{{ dioForm.repeatCount }}</el-form-item>
                            </el-col> -->

                            <el-col :span="8">
                                <el-form-item :label="$t('integration.alarm_interval')" prop="alarmTime">{{
                                    dioForm.repeatInterval }} - {{ dioForm.intervalUnit | unitFilter }} </el-form-item>
                            </el-col>
                        </template>
                    </el-col>
                </template>

                <el-col :span="24">
                    <el-form-item :label="$t('integration.alarm_strategy')" prop="strategy">
                        <div class="reasonClass">
                            <div class="textDiv uk-text-center" style="margin-right: 5px;">{{ $t(dioForm.strategy ?
                                alarmStrategy[dioForm.strategy].title : alarmStrategy[1].title) }}</div>
                            <i class="el-icon-question cursor-pointer"
                                :title="$t(dioForm.strategy ? alarmStrategyTip[dioForm.strategy].title : alarmStrategyTip[1].title)"></i>
                        </div>
                    </el-form-item>
                </el-col>
            </el-form>
            <!-- 层级区域 -->
            <el-col :span="24">
                <LevelContent v-show="isEdit" :LevelContentArray="LevelContentArray" :sceneId="sceneId"
                    ref="LevelContent" />
                <PublicContent ref="public" v-show="!isEdit" :editForm="editForm" v-bind="$attrs" @goBack="goBack"
                    :ParenList="ContactsList" />
            </el-col>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" v-show="!isEdit" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import LevelContent from './LevelContent.vue';
import PublicContent from './PublicContent.vue';

import { alarmContactsList, alarmeditAlarmTrigger } from '@/api/modules/alarm.js';
import mixinRange from '@/utils/getRange.js';
import { alarmStrategy, alarmStrategyTip } from '@/utils/convert';
export default {
    props: ['isShow', 'title', 'detailObj'],
    components: {
        LevelContent,
        PublicContent
    },
    mixins: [mixinRange],
    filters: {
        filterFn(value) {
            switch (value) {
                case '0': {
                    return $t('public.ex_conn');
                }
                case '1': {
                    return $t('public.ex_data');
                }
                case '2': {
                    return $t('public.ex_power');
                }
                default:
                    break;
            }
        },
        timeWeek(value) {
            switch (value) {
                case 1: {
                    return $t('public.monday');
                }
                case 2: {
                    return $t('public.tuesday');
                }
                case 3: {
                    return $t('public.wednesday');
                }
                case 4: {
                    return $t('public.thursday');
                }
                case 5: {
                    return $t('public.friday');
                }
                case 6: {
                    return $t('public.saturday');
                }
                case 7: {
                    return $t('public.sunday');
                }
                default:
                    break;
            }
        },
        unitFilter(num) {
            return num === 0 ? $t('public.second') : num === 1 ? $t('public.minute') : $t('public.hour');
        }
    },
    watch: {
        detailObj(newVal) {
            // 编辑使用
            this.editForm = JSON.parse(JSON.stringify(newVal));
            this.dioForm = { ...newVal };
            //  原因的数据改造
            this.reasonArray = newVal.reason.split(',').map(item => {
                return {
                    checked: true,
                    checkValue: item
                };
            });
            // 范围id
            this.sceneId = newVal.sceneId;

            // 报警时间的数据改造
            this.timePoint = newVal.alarmTriggerTimeList.map(item => {
                item.alarmTimeList = item.time ? JSON.parse(item.time) : [];

                return item;
            });
            // 报警层级的内容获取传递
            this.LevelContentArray = newVal.alarmTriggerHierarchyList;
        }
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow;
            },
            set: function (val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        },
        rules() {
            return {};
        }
    },
    data() {
        return {
            alarmStrategy,
            alarmStrategyTip,
            dioForm: {},
            editForm: {},
            // 是否是查阅模式
            isConsultMode: true,
            //原因
            reasonArray: [],
            // 时间点
            timePoint: [],
            // 层级
            LevelContentArray: [],
            // 范围id
            sceneId: '',
            isEdit: true,
            // 联系人
            ContactsList: []
        };
    },
    methods: {
        resetFn() {
            this.isEdit = true;
            this.$refs['public'].isShowMsg = false;
        },
        getAgainFn() {
            this.isShowDialog = false;
            this.$emit('AgainFn');
        },

        goback(bool) {
            this.isEdit = bool;
        },
        handleEditFn() {
            this.isEdit = !this.isEdit;
            // 获取联系人
            this.getContactList();
        },
        getContactList() {
            alarmContactsList({ sceneId: this.sceneId }).then(({ result }) => {
                this.ContactsList = result;
            });
        },
        async handleSave() {
            let flag = await this.$refs['public'].justify();
            if (!flag) return;
            let queryParam = this.$refs['public'];
            if (!flag) return;
            const { sceneId, name, reason, type, repeatCount, repeatInterval, intervalUnit, alarmTriggerTimeList, id, strategy } = queryParam.dioForm;
            let alarmTime = [];
            alarmTriggerTimeList.map(item => {
                alarmTime.push({
                    alarmTime: item.alarmTime,
                    alarmTimeList: item.alarmTimeList.map(opt => {
                        return {
                            endTime: opt.time[1],
                            startTime: opt.time[0]
                        };
                    })
                });
            });
            let query = {
                sceneId,
                name,
                reason: reason.join(','),
                type,
                repeatCount,
                repeatInterval,
                intervalUnit,
                alarmTriggerTimeList: alarmTime,
                id,
                strategy
            };
            let level = queryParam.$refs['level'].alarmTriggerHierarchyList;
            let alarmTriggerHierarchyList = [];
            alarmTriggerHierarchyList = level.map((item, index) => {
                item.alarmContactList = item.dioForm.tableData.map(opt => {
                    return {
                        // id: !opt.name ? opt.userId : null,
                        name: opt.name,
                        alarmWay: opt.alarmWay,
                        phone: opt.phone,
                        email: opt.email
                    };
                });

                item.abnormalDelayList = item.abnormalDelayList.map(row => {
                    return {
                        type: row.type,
                        delayNum: row.delayNum,
                        unit: row.unit
                    };
                });

                return {
                    name: item.name,
                    sort: index + 1 + '',
                    alarmContactList: item.alarmContactList,
                    abnormalDelayList: item.abnormalDelayList,
                    sign: queryParam.$refs['level'].userShow ? 1 : 0
                };
            });
            query.alarmTriggerHierarchyList = alarmTriggerHierarchyList;

            alarmeditAlarmTrigger(query).then(async ({ state }) => {
                await this.$resultHandle(state);
                this.isShowDialog = false;
                // this.$parent.getListFn()

                this.$emit('confirm', query);
            });
        },
        goBack() {
            this.isEdit = !this.isEdit;
        }
    }
};
</script>

<style lang="scss" scoped>
.detailContent {
    height: 450px;
    overflow: auto;
}

.alarmTime {
    height: 30px;
    border: 1px solid var(--primary-color);
    box-sizing: border-box;
    border-radius: 2px;
    display: flex;
    width: 80%;

    &:not(:first-child) {
        margin-top: 15px;
    }

    .weekClass {
        height: 100%;
        width: 60px;
        text-align: center;
        font-size: 14px;
        background-color: var(--primary-color);
        color: #fff;
        margin-right: 15px;
    }

    .timePoint {
        display: flex;
        height: 100%;
        border-radius: 2px;

        .timepointContent {
            height: 100%;
            margin-right: 15px;

            .time {
                display: inline-block;
                text-align: center;
                width: 60px;
                height: 100%;
                background-color: var(--primary-color);
                color: #fff;
            }
        }
    }
}

.disClass {
    display: flex;
    justify-content: space-between;
}

.reasonClass {
    display: flex;
    width: 100%;
    align-items: center;

    .reasonRontent {
        border: 1px solid var(--primary-color);
        height: 30px;
        margin-right: 15px;
        // box-sizing: border-box;
        display: flex;
        border-radius: 2px;
    }

    .textDiv {
        background-color: var(--primary-color);

        color: #fff;
        font-size: 14px;
        padding: 0 5px;
    }

    &>.textDiv {
        border-radius: 2px;
    }

    .m5 {
        margin: 0 5px;
    }
}
</style>
